import { KVTagMetadata } from './KVAnnotation'
import {
  KVMeasurementSegment,
  KVMeasurementSegmentJSON,
} from './KVMeasurementSegment'

export type KVMeasurementJSON = {
  measurementId: string
  measurementVisible: boolean
  measurementLabel: string
  measurementSegments: KVMeasurementSegmentJSON[]
  isMeasurementFinalized?: boolean
  measurementTags?: Record<string, KVTagMetadata>
  userName?: string
  userEmail?: string
  createdAt?: string
}

export class KVMeasurement {
  id: string
  visible: boolean
  label: string
  segments: KVMeasurementSegment[]
  isMeasurementFinalized?: boolean
  tags: Record<string, KVTagMetadata>
  userName: string
  userEmail: string
  createdAt: string

  constructor(id: string) {
    this.id = id
    this.segments = []
    this.visible = true
    this.label = ''
    this.isMeasurementFinalized = false
    this.tags = {}
    this.userName = ''
    this.userEmail = ''
    this.createdAt = new Date().toISOString()
  }

  static fromJSON(json: KVMeasurementJSON): KVMeasurement {
    const measurement = new KVMeasurement(json.measurementId)
    if (json.measurementVisible !== undefined)
      measurement.visible = json.measurementVisible
    if (json.measurementLabel) measurement.label = json.measurementLabel
    if (json.measurementSegments) {
      measurement.segments = json.measurementSegments.map(
        KVMeasurementSegment.fromJSON
      )
    }
    if (json.isMeasurementFinalized !== undefined)
      measurement.isMeasurementFinalized = json.isMeasurementFinalized
    measurement.tags = json.measurementTags ?? {}
    if (json.userName) measurement.userName = json.userName
    if (json.userEmail) measurement.userEmail = json.userEmail
    if (json.createdAt) measurement.createdAt = json.createdAt
    return measurement
  }

  static toJSON(measurement: KVMeasurement): KVMeasurementJSON {
    return {
      measurementId: measurement.id,
      measurementSegments: measurement.segments.map(
        KVMeasurementSegment.toJSON
      ),
      measurementVisible: measurement.visible,
      measurementLabel: measurement.label,
      measurementTags: measurement.tags,
      userName: measurement.userName,
      userEmail: measurement.userEmail,
      createdAt: measurement.createdAt,
    }
  }
}
